import type { TableType } from './TableSelector';

interface FilterPanelProps {
  activeTable: TableType;
  statusFilters: string[];
  onStatusChange: (statuses: string[]) => void;
  onApply: () => void;
  onClear: () => void;
}

const STATUS_OPTIONS: Record<TableType, string[]> = {
  seeds: ['New', 'Processed'],
  briefs: ['Ready', 'In Writing', 'In Editing', 'Staged', 'Published'],
  drafts: ['Draft', 'In Editing', 'Staged', 'Published'],
};

export function FilterPanel({ activeTable, statusFilters, onStatusChange, onApply, onClear }: FilterPanelProps) {
  const statuses = STATUS_OPTIONS[activeTable];

  const toggleStatus = (status: string) => {
    if (statusFilters.includes(status)) {
      onStatusChange(statusFilters.filter((s) => s !== status));
    } else {
      onStatusChange([...statusFilters, status]);
    }
  };

  return (
    <>
      <div class="filters-section">
        <div class="filter-group">
          <div class="filter-group-title">Status</div>
          {statuses.map((status) => (
            <label class="filter-option" key={status}>
              <input
                type="checkbox"
                checked={statusFilters.includes(status)}
                onChange={() => toggleStatus(status)}
              />
              <span>{status}</span>
            </label>
          ))}
        </div>
      </div>
      <div class="filter-actions">
        <button class="filter-btn filter-btn-clear" onClick={onClear}>Clear All</button>
        <button class="filter-btn filter-btn-apply" onClick={onApply}>Apply Filters</button>
      </div>
    </>
  );
}
